import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';


const workflowSlice = createSlice({
  initialState,
  reducers,
  name: 'workflowEditor',
});

export const {
  appendThresholdToLinkedAction,
  applyWorkflowDataSnapshot,
  applyWorkflowPropsSnapshot,
  removeThresholdFromLinkedAction,
  applyPrevWorkflowDataSnapshot,
  clearWorkflowSnapshots,
  createActionOutputExpressionItem,
  addAction,
  addThreshold,
  createActions,
  createDataRoute,
  createThreshold,
  clearActionRulesOperatorAmbiguousMode,
  createWorkflowOperationMessage,
  deleteThreshold,
  dismissWorkflowOperationMessage,
  groupActionOutputExpressionItem,
  initWorkflowPropsAndData,
  replaceWorkflowDataGraph,
  resetWorkflowEditorState,
  replaceWorkflowProps,
  removeAction,
  removeActionOutputExpressionItem,
  removeDataRoute,
  removeSubsequentWorkflowDataSnapshots,
  removeThreshold,
  switchThresholdToDynamicComparison,
  switchThresholdToStaticComparison,
  ungroupActionOutputExpressionItem,
  updateAction,
  addActionOutputExpressionOperatorToOperand,
  addActionOutputExpressionTrailingOperator,
  settleActionOutputExpressionFunctions,
  replaceActionOutputExpressionItem,
  updateActionOutputExpressionFunction,
  updateActionOutputExpressionItem,
  updateCanvasProperties,
  updateDataRouteValue,
  updateDependencies,
  updateSdkConfig,
  updateServiceActionValidation,
  updateThreshold,
  updateThresholdAgnostic,
  updateWorkflowDataDependencies,
  // props
  updateWorkflowProps,
  updateWorkflowSnapshots,
  addEphemeralTagToProps,
  updateTagInProps,
  addEphemeralOutcomeToProps,
  removeEphemeralProp,
  addEphemeralPublishedAttributeToProps,
  addEphemeralReasonCodeGroupToProps,
  removeEphemeralReasonCodeGroupFromProps,
  updatePublishedAttributeInProps,
  addEphemeralListToProps,
  addEphemeralCustomListToProps,
  addEphemeralAttributeToProps,
  updateSnippetsMetadataInProps,
  // ui reducers
  setDiffMode,
  resetNodeAndConnectorState,
  setActiveNodeEditorTab,
  setIsTagSwapMode,
  setConnectorInteractionState,
  setConnectorOwnerNodeId,
  setConnectorCanCreateItemStatus,
  setFloatedAnchorNodeId,
  setFocusedNodeId,
  setHighlightedNodeId,
  setHoveredNodeId,
  setNodeFolderCollapsed,
  setSnippetCollapsed,
  setEditorContainerType,
  setShouldRenderCriticalNodePath,
  openMenuBarModal,
  closeMenuBarModal,
  // linkedChildAction reducers
  resetLinkedChildActionState,
  setLinkedChildActionCreateActionPayload,
  setLinkedChildActionOwnerNodeId,
  updateLinkedChildActionThresholdIds,
  // component state
  resetComponentState,
  setServiceRoutingCategoryNameInEditing,
  setServiceActionOptionPublicIdInEditing,
  addDeactivatedLegacyDataRoute,
  clearDeactivatedLegacyDataRoutes,
  // search
  setIsSearchBoxVisible,
  setSearchMatchIndex,
  setSearchQuery,
  // ai chat
  openAiChatPanel,
  closeAiChatPanel,
  // RuleBuilder
  setRuleBuilderActiveRuleNumberDropdownId,
  setRuleBuilderIsDragging,
  setRuleBuilderHighlightedRuleId,
  setRuleBuilderHoveredRuleIndex,
  setRuleBuilderPendingGroupInfo,
  setRuleBuilderPanelBoxContainerWidth,
  setRuleBuilderActiveSubEditor,
  resetRuleBuilderSubEditor,
  resetRuleBuilderPendingGroup,
  // ExpressionBuilder
  setPendingGroup,
  resetPendingGroup,
  // Expressions
  setExpressionActiveSubEditor,
  resetExpressionSubEditor,
  // workflowLock reducers
  setCheckoutWorkflowData,
  // misc
  updateFailureHandlingMode,
  // workflowFeatures
  setThresholdOutputResults,
  setIsRuleExplainabilityPortfolioEvaluation,
  setEntityToken,
  setEvaluationToken,
  setDimensions,
  setEvaluationTagNames,
  setEvaluationOutcome,
  setSelectedEvidenceThresholdId,
  setSelectedThresholdSimThresholdId,
  setMatrixModelResults,
  // snippets
  setPreSnippetWorkflowDataSnapshot,
  setPreSnippetWorkflowPropsSnapshot,
  setSnippetIncompatibleActions,
  setSnippetMode,
  setSnippetActiveOperation,
  setSnippetMetadata,
  setSnippetPreviewData,
  // workflow history
  discardRedoStack,
  appendWorkflowHistoryEntry,
  applyHistoryTraversal,
  clearPendingWorkflowHistoryTransaction,
  setPendingWorkflowHistoryTransaction,
} = workflowSlice.actions;

export default workflowSlice.reducer;
